// A small product image thumbnail for the OMS line/item tables. Renders a 40x40
// image with click-to-preview; falls back to a neutral placeholder when the variant
// has no image (image_url null) OR when the stored URL fails to load (dead/404 links
// are common in dev data, and AntD's default broken-image glyph looks like a bug).
import { PictureOutlined } from "@ant-design/icons";
import { Image } from "antd";
import React, { useEffect, useState } from "react";

const SIZE = 40;

const Placeholder: React.FC = () => (
  <div
    aria-label="no image"
    style={{
      width: SIZE,
      height: SIZE,
      borderRadius: 4,
      background: "#f5f5f5",
      border: "1px solid #f0f0f0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#bfbfbf",
    }}
  >
    <PictureOutlined />
  </div>
);

const ProductThumb: React.FC<{ src?: string | null; alt?: string }> = ({
  src,
  alt,
}) => {
  const [failed, setFailed] = useState(false);

  // Reset the failed flag if the row is reused for a different product (virtualised
  // tables / refetch reuse component instances).
  useEffect(() => setFailed(false), [src]);

  if (!src || failed) return <Placeholder />;

  return (
    <Image
      src={src}
      alt={alt || "product"}
      width={SIZE}
      height={SIZE}
      style={{ objectFit: "cover", borderRadius: 4 }}
      preview={{ mask: null }}
      onError={() => setFailed(true)}
    />
  );
};

export default ProductThumb;
